import React from 'react';
import Image from 'next/image';
import Link from '../Link';
import { Button } from '@mui/material';
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import FavoriteIcon from '@mui/icons-material/Favorite';
// import { useSelector, useDispatch } from 'react-redux'
// import { notas as notasDispatch } from '../../redux/favoritos/favoritosSlice'
import styles from './styles.module.scss';

type ItemNotaProps = {
    data: any
    isCarousel?: boolean
}

const ItemNota = (props: ItemNotaProps) => {

  const nota = props.data;
  const isCarousel = props.isCarousel;

  return (<>
    <div className={`${styles.item} ${isCarousel ? styles.itemCarousel : ''}`}>
      {nota.attributes?.destacado && <div className={styles.cucarda}>Destacada</div>}
      <div className={styles.up}>
        <Image
          src={nota.attributes?.portada?.data?.attributes?.url || "https://dummyimage.com/1400x500/000000/ffffff"}
          alt={nota.attributes?.titulo}
          width={280}
          height={100}
          style={{ borderRadius: "6px", width: "100%", maxWidth: "100%", height: "auto" }}
        />
        {/* <Fav nota={nota}/> */}
      </div>
      <div className={styles.down}>
        <h3 className={styles.nombre} title={nota.attributes?.titulo}>{nota.attributes?.titulo || '-'}</h3>
        <p className={styles.descripcion}>{nota.attributes?.descripcionCorta || '-'}</p>
        <br />
        <Link href={`/inspo/${nota.attributes?.slug}`}>
          <Button
            variant="contained"
            color="primary"
            style={{
              width: '100%',
            }}
          >Leer nota</Button>
        </Link>

      </div>
    </div>
  </>);
};

export default ItemNota;

// export const Fav = (props)=>{
//     const dispatch = useDispatch();
//     const notasFavoritas = useSelector((state) => state.favoritos.notas)

//     const handleFav = async (nota)=>{
//         dispatch(notasDispatch(nota))
//     }

//     return(
//         <button className={styles.favButton} onClick={()=>handleFav(props.nota)} aria-label="Agregar a mi wishlist">
//             {(notasFavoritas?.find(v => v.id == props.nota.id)) ?
//                 <FavoriteIcon style={{color: "#333"}} />
//             :
//                 <FavoriteBorderIcon style={{color: "#333"}} />
//             }
//         </button>
//     )
// }
